function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 36,
    viewBox: "0 0 22.5 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-mobile-alt",
    d: "M19.125 0H3.375A3.376 3.376 0 0 0 0 3.375v29.25A3.376 3.376 0 0 0 3.375 36h15.75a3.376 3.376 0 0 0 3.375-3.375V3.375A3.376 3.376 0 0 0 19.125 0zM11.25 33.75a2.25 2.25 0 1 1 2.25-2.25 2.248 2.248 0 0 1-2.25 2.25zm7.875-7.594a.846.846 0 0 1-.844.844H4.219a.846.846 0 0 1-.844-.844V4.219a.846.846 0 0 1 .844-.844h14.062a.846.846 0 0 1 .844.844z",
    style: {
      fill: "#ed3833"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone_call.2e1fabdbe2515dab469e28242dd6b060.svg";
export { ForwardRef as ReactComponent };